import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IAssignManufacturerForm } from 'bom/types';
import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { FormProvider, useNotificationContext } from 'core/states';
import { IOption } from 'core/types';
import { manufacturerService } from 'parts/services';
import { IManufacturer } from 'parts/types';

import { assignManufacturerSchema } from './schema';

interface IProps {
  isOpen: boolean;
  onSubmit: (data: IAssignManufacturerForm) => void;
  onClose: () => void;
  options?: IOption[];
  isAlternateVersionEnabled?: boolean;
}

const AssignManufacturerForm = ({
  isOpen,
  onSubmit,
  onClose,
  options = [],
  isAlternateVersionEnabled = false,
}: IProps) => {
  const { t } = useTranslation();
  const { clearNotification } = useNotificationContext();

  const handleOnSubmit =
    (reset: UseFormReset<IAssignManufacturerForm>) => (data: IAssignManufacturerForm) => {
      onSubmit(data);
      handleOnClose(reset);
    };

  const handleOnClose = (reset: UseFormReset<IAssignManufacturerForm>) => {
    clearNotification();
    reset();
    onClose();
  };

  const optionsProps =
    options.length > 0
      ? { options }
      : {
          getOptions: manufacturerService.getMany,
          requestPayload: { alternateVersionEnabled: isAlternateVersionEnabled ? 1 : 0 },
        };

  return (
    <FormProvider schema={assignManufacturerSchema(options.length > 0)}>
      <Form
        title={t('titleAssignManufacturer')}
        isOpen={isOpen}
        onClose={handleOnClose}
        onSubmit={handleOnSubmit}
        submitBtnLabel={t('buttonLabelAssignManufacturer')}
      >
        <FormField
          name="manufacturer"
          type={options.length > 0 ? InputType.SELECT : InputType.AUTOCOMPLETE}
          inputProps={{
            label: t('labelManufacturer'),
            placeholder: t('placeholderChooseManufacturer'),
            getLabel: (option: IManufacturer) => option.name,
            required: true,
            ...optionsProps,
          }}
        />
      </Form>
    </FormProvider>
  );
};

export default AssignManufacturerForm;
